import React from 'react';
import PropTypes from 'prop-types';
import { Header, Sidebar } from '.';

const Base = (props) => (
    <div id="page-wrapper">
        <div id="page-container" className="header-fixed-top sidebar-light sidebar-visible-lg-full">
            <Sidebar />
            <div id="main-container">
                <Header />
                <div id="page-content">{props.children}</div>
            </div>
        </div>
    </div>
);
Base.propTypes = {
    children: PropTypes.node
};
export default Base;
